import React from 'react';
import './each_location.css';
import { Container } from "react-bootstrap";
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';


const Hero_Section_Two = (props) => {

    return (
        <>
            <img className="hero-two" src={props.valDataOne.hero_img.data[0].attributes.formats.large.url} />
            <Container>
                <div className="caption-loc" style={{ flexWrap: 'wrap' }}>
                    <h6 className="py-3" style={{ textTransform: 'uppercase', textAlign: 'center', fontSize: '20px', color: '#fff' }}>{props.valDataOne.location_name}</h6>
                </div>
            </Container>
            <Container className="py-3 d-flex justify-content-center">
                <Container className="mb-3">
                    <ReactMarkdown rehypePlugins={[rehypeRaw]} remarkPlugins={[remarkGfm]} className="align-middle">
                        {props.valDataOne.location_intro}
                    </ReactMarkdown>
                </Container>
            </Container>
        </>
    );
};

export default Hero_Section_Two